import script from "./Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Card.vue?vue&type=script&setup=true&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=008da956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008da956"]])

export default __exports__